export default "__VITE_ASSET__DL9yBsxf__"